import dynamic from "next/dynamic";
import { ComponentConfig } from "@zapier/builder.io-kit";

export const simplePlanCardCollectionConfig: ComponentConfig = {
  name: "SimplePlanCardCollection",
  category: "Pricing",
  component: dynamic(() => import("./SimplePlanCardCollection")),
  includeScrollTracking: true,
  inputs: [
    {
      name: "stateKey",
      type: "string",
      required: true,
      helperText:
        "An identifier that should match any other component(s) on the page that should cause this component to be updated.",
    },
    {
      name: "plans",
      type: "list",
      subFields: [
        {
          name: "type",
          type: "string",
          enum: ["Basic", "Premium", "Advanced"],
          defaultValue: "Free",
        },
        {
          name: "description",
          type: "longText",
        },
        {
          name: "primaryCTA",
          friendlyName: "Primary CTA",
          type: "object",
          subFields: [
            {
              name: "color",
              type: "string",
              enum: ["primary", "primary-alt", "secondary"],
            },
            {
              name: "text",
              type: "string",
            },
            {
              name: "href",
              type: "string",
              helperText:
                "If left empty, the href will be automatically generated using the selected plan and currency",
            },
          ],
        },
        {
          name: "pricingDetails",
          type: "string",
          enum: ["Free forever", "Per month"],
        },
        {
          name: "productID",
          type: "string",
          required: true,
          helperText:
            "The ID of the product whose price will be displayed; for example, tables-premium is the ID of the Tables Premium add-on.",
        },
        {
          name: "price",
          type: "number",
          helperText: "This value must be provided in cents",
        },
      ],
      defaultValue: [
        {
          type: "Basic",
          description: "Included free in all Zapier plans",
          primaryCTA: {
            color: "primary",
            text: "Try it free",
          },
          pricingDetails: "Free forever",
          productID: "chatbots-free",
        },
        {
          type: "Premium",
          description: "For individuals who want to build professional apps.",
          primaryCTA: {
            color: "primary",
            text: "Buy now",
          },
          pricingDetails: "Per month",
          productID: "chatbots-premium",
        },
        {
          type: "Advanced",
          description:
            "For teams that want to collaborate and build for themselves and customers.",
          primaryCTA: {
            color: "primary",
            text: "Buy now",
          },
          pricingDetails: "Per month",
          productID: "chatbots-advanced",
        },
      ],
    },
  ],
};
